import { useMemo } from 'react';
import { hexToRgb } from '~/shared';
import { StyledDot, StyledSwitch } from './AppConnectionSwitch.styled';

interface AppConnectionSwitchProps {
	x: number;
	y: number;
	isVertical: boolean;
	isActive: boolean;
	colors?: {
		inactive: string;
		active: string;
	};
	handleSwitch: () => void;
}

const AppConnectionSwitch = ({
	x,
	y,
	isVertical,
	colors,
	isActive,
	handleSwitch,
}: AppConnectionSwitchProps) => {
	const color = useMemo(() => {
		if (isActive) {
			return colors?.active || '#6FFF00';
		}

		return colors?.inactive || '#FF0000';
	}, [isActive, colors]);

	const shadowColor = useMemo(() => {
		const rgb = hexToRgb(color);

		return `rgba(${rgb.r}, ${rgb.g}, ${rgb.b}, 0.75)`;
	}, []);

	return (
		<StyledSwitch
			$isVertical={isVertical}
			onClick={handleSwitch}
			style={{ left: x, top: y }}
		>
			<StyledDot
				$isActive={isActive}
				$isVertical={isVertical}
				style={{
					backgroundColor: color,
					boxShadow: `0px 0px 4px ${shadowColor}`,
				}}
			/>
		</StyledSwitch>
	);
};

export { AppConnectionSwitch };
